import React from 'react';
export var InteractiveDiagramContext = React.createContext(undefined);
export var InteractiveDiagramProvider = InteractiveDiagramContext.Provider;
export var InteractiveDiagramConsumer = InteractiveDiagramContext.Consumer;
export var useInteractiveDiagramContext = function () {
    return React.useContext(InteractiveDiagramContext);
};
//# sourceMappingURL=InteractiveDiagramContext.js.map